"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var MasterCardIcon = function MasterCardIcon(_ref) {
  var width = _ref.width,
      height = _ref.height,
      viewBox = _ref.viewBox,
      isDark = _ref.isDark;
  var light = {
    inner: '#FF5F00',
    left: '#EB001B',
    center: '#F79E1B',
    right: '#F79E1B'
  };
  var dark = {
    inner: '#666666',
    left: '#9E9E9E',
    center: '#979797',
    right: '#979797'
  };
  var fill = light;

  if (isDark) {
    fill = dark;
  }

  return /*#__PURE__*/_react["default"].createElement("svg", {
    width: width,
    height: height,
    viewBox: viewBox,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    id: "inner",
    d: "M30 15H20V33H30V15Z",
    fill: fill.inner
  }), /*#__PURE__*/_react["default"].createElement("path", {
    id: "left",
    d: "M20.7507 23.9985C20.7494 22.3329 21.1312 20.6888 21.8674 19.1907C22.6036 17.6926 23.6748 16.3796 25 15.3513C23.3587 14.0759 21.3877 13.2829 19.3121 13.0628C17.2365 12.8426 15.1402 13.2043 13.2627 14.1064C11.3851 15.0085 9.8022 16.4147 8.69475 18.1642C7.58729 19.9138 7 21.9361 7 24C7 26.0639 7.58729 28.0862 8.69475 29.8358C9.8022 31.5853 11.3851 32.9915 13.2627 33.8936C15.1402 34.7957 17.2365 35.1574 19.3121 34.9373C21.3877 34.7171 23.3587 33.9241 25 32.6487C23.6744 31.6201 22.603 30.3066 21.8668 28.808C21.1305 27.3093 20.7489 25.6646 20.7507 23.9985Z",
    fill: fill.left
  }), /*#__PURE__*/_react["default"].createElement("path", {
    id: "center",
    d: "M42.23 31V30.1714H42.3967V30H42V30.1714H42.1567V31H42.23ZM43 31V30H42.88L42.74 30.7143L42.6 30H42.48V31H42.5667V30.2429L42.6967 30.8929H42.7867L42.9167 30.2429V31H43Z",
    fill: fill.center
  }), /*#__PURE__*/_react["default"].createElement("path", {
    id: "right",
    d: "M43 24.0015C43 26.0654 42.4126 28.0876 41.305 29.837C40.1975 31.5864 38.6144 32.9923 36.7369 33.8942C34.8593 34.7961 32.7629 35.1575 30.6874 34.9371C28.6119 34.7167 26.641 33.9233 25 32.6477C26.3245 31.6186 27.3953 30.3054 28.1317 28.8074C28.868 27.3094 29.2506 25.6656 29.2506 24C29.2506 22.3344 28.868 20.6906 28.1317 19.1926C27.3953 17.6946 26.3245 16.3814 25 15.3523C26.641 14.0767 28.6119 13.2833 30.6874 13.0629C32.7629 12.8425 34.8593 13.2039 36.7369 14.1058C38.6144 15.0077 40.1975 16.4136 41.305 18.163C42.4126 19.9124 43 21.9346 43 23.9985V24.0015Z",
    fill: fill.right
  }));
};

MasterCardIcon.defaultProps = {
  isDark: false,
  width: '48',
  height: '48',
  viewBox: '0 0 48 48'
};
MasterCardIcon.propTypes = {
  /**
   * use darkTheme
   */
  isDark: _propTypes["default"].bool,

  /**
   * the width of the icon
   */
  width: _propTypes["default"].string,

  /**
   * the height of the icon
   */
  height: _propTypes["default"].string,

  /**
   * the viewbox of the svg that wraps the icon
   */
  viewBox: _propTypes["default"].string
};
var _default = MasterCardIcon;
exports["default"] = _default;